import React from 'react';
import {
  Label, FormGroup, Col, Input,
} from 'reactstrap';
import isEmpty from 'lodash/isEmpty';

const RenderFilePicker = ({
  input: { onChange },
  label,
  name,
}) => (
  <FormGroup row>
    {!isEmpty(label) && (
    <Label for={name} sm="2">
      {label}
    </Label>
    )}
    <Col sm="10">
      <Input
        type="file"
        name="reports"
        id={name}
        multiple
        onChange={onChange}
      />
    </Col>
  </FormGroup>
);

export default RenderFilePicker;
